import React, { Component } from "react";
import theme from "../../App.module.sass";
import styles from "./Header.module.sass";

import Breadcrumb from "../Breadcrumb/Breadcrumb";
import AppContext from "../../contexts/appContext";
import routerWrapper from "../../hoc/RouterWrapper";
import DataConsentQuestion from "../DataConsentQuestion";

const getHeaderText = (condition, component) => {
  if(!condition){
    return ""
  }
  return component
}
class Header extends Component {
  state = {
    activeIndex: 0,
  };

  static contextType = AppContext;

  componentDidUpdate(prevProps, prevState, prevContext) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.context.setContext({
        ...this.context,
        pathname: this.props.location.pathname,
      });
    }

    this.updateIndex();
  }

  componentDidMount() {
    this.updateIndex();
  }

  updateIndex() {
    let selectedIndex = 0;
    switch (this.props.location.pathname) {
      case "/confirmar-oferta":
        selectedIndex = 1;
        break;
      case "/identificacao":
        selectedIndex = 2;
        break;
      case "/dados-cliente":
        selectedIndex = 3;
        break;
      case "/seguro":
        selectedIndex = 4;
        break;
      case "/pagamento":
        selectedIndex = 5;
        break;
      case "/assinatura":
        selectedIndex = 6;
        break;
      default:
        selectedIndex = 0;
        break;
    }
    if (this.state.activeIndex !== selectedIndex) {
      this.setState({ activeIndex: selectedIndex });
    }
  }

  render() {
    const headerIBC = (
      <h2 className={styles.headerText}>
        Carregando os serviços de integração.
      </h2>
    );

    const headerProducts = (
      <>
      <h2 className={styles.headerText}>
        Veja como um consórcio pode ajudar a <b>realizar seus sonhos </b> e
        compre agora <b>:)</b>
      </h2>
      <DataConsentQuestion />
      </>
    );

    const headerOffers = (
      <>
      <h2 className={styles.headerText}>
        {" "}
        {this.context.title ? (
          this.context.title
        ) : (
          <React.Fragment>
            Ofertas disponíveis<b> pra você! </b>
          </React.Fragment>
        )}
        <p className={styles.subtitle}>
          {this.context.subtitle ? (
            this.context.subtitle
          ) : (
            <React.Fragment>
              As cotas apresentadas estão sujeitas a disponibilidade
            </React.Fragment>
          )}
        </p>
      </h2>
      <DataConsentQuestion />
      </>
    );

    const headerConfirmOffers = (
      <>
      <h2 className={styles.headerText}>
        {" "}
        Esta é<b> a sua escolha: </b>
      </h2>
      <DataConsentQuestion />
      </>
    );

    const headerIdentification = (
      <>
      <h2 className={styles.headerText}>
        Do que você precisa saber para comprar o seu
        <b> Consórcio {this.context.product.id === "1" ? "Imobiliário" : "de Veículos"}. </b>
      </h2>
      <DataConsentQuestion />
      </>
    );

    const headerNewUserPF = (
      <>
      <h2 className={styles.headerText}>
        Agora é necessário preencher seus dados e enviar alguns documentos
      </h2>
      <DataConsentQuestion />
      </>
    );

    const headerNewUserPJ = (
      <h2 className={styles.headerText}>
        Agora é necessário preencher os dados da empresa e enviar alguns
        documentos
      </h2>
    );

    const headerInsurance = (
      <h2 className={styles.headerText}>Deixe sua família bem cuidada</h2>
    );

    const headerPayment = (
      <h2 className={styles.headerText}>
        Falta pouco :) <br /> Escolha agora como deseja pagar
      </h2>
    );

    const headerSignature = (
      <h2 className={styles.headerText}>
        Parabéns! Seu pedido foi finalizado. O número da sua proposta é{" "}
        {this.context.proposalCode}
      </h2>
    );

    const headerDocuments = (
      <h2 className={styles.headerText}>
        Baixe aqui os <b>documentos da sua proposta! </b>
      </h2>
    );

    const pathname = this.props.location.pathname.replace("/", "");
    const personType =
      this.context.selectedIdentifier != null
        ? this.context.selectedIdentifier
        : "";

    const ibc =
      this.props.location.search.includes("token") || this.context.ibc;

    return (
      <header className={[theme.header, ibc ? theme.ibc : ""].join(" ")}>
        {pathname !== "" &&
        pathname !== "produtos" &&
        pathname !== "ofertas" &&
        !pathname.includes("documentos") &&
        pathname !== "sucesso" ? (
          <Breadcrumb
            ibc={ibc}
            personType={personType}
            activeIndex={this.state.activeIndex}
          />
        ) : null}

        <div className={styles.headerMain}>
          <h1 className={styles.planText}>
            <i className="icon icon-consorcio" />
            Consórcios
          </h1>
        </div>
        {getHeaderText(pathname === "", headerIBC)}
        {getHeaderText(pathname === "produtos", headerProducts)}
        {getHeaderText(pathname === "ofertas",headerOffers)}
        {getHeaderText(pathname === "confirmar-oferta", headerConfirmOffers)}
        {getHeaderText(pathname === "identificacao", headerIdentification)}
        {getHeaderText(pathname === "dados-cliente" && personType === "cpf", headerNewUserPF)}
        {getHeaderText(pathname === "dados-cliente" && personType === "cnpj", headerNewUserPJ)}
        {getHeaderText(pathname === "seguro", headerInsurance)}
        {getHeaderText(pathname === "pagamento", headerPayment)}
        {getHeaderText(pathname === "assinatura", headerSignature)}
        {getHeaderText(pathname.includes("documentos"), headerDocuments)}
      </header>
    );
  }
}

export default routerWrapper(Header);
